import React from "react";
import { AUTH_KEY } from "./utils/auth/Authentication";

const DashboardView = React.lazy(() => import("./views/pages/dashboard/Dashboard"));
const BranchAnalytics = React.lazy(() => import("./views/pages/branchAnalytics/BranchAnalytics"));
const NotAuthorized = React.lazy(() => import("./views/pages/page404/PageNotAuthorized"));
const CAB = React.lazy(() => import("./views/pages/cashAndBanks/CashAndBanks"));
const CABActions = React.lazy(() => import("./views/pages/cashAndBanks/Actions"));
const COA = React.lazy(() => import("./views/pages/chartOfAccounts/ChartOfAccounts"));
const COAActions = React.lazy(() => import("./views/pages/chartOfAccounts/Actions"));
const AccountTrx = React.lazy(() => import("./views/pages/accountTransactions/AccountTransactions"));
const AccountTrxActions = React.lazy(() => import("./views/pages/accountTransactions/Actions"));
const Roles = React.lazy(() => import("./views/pages/roles/Roles"));
const Products = React.lazy(() => import("./views/pages/products/Products"));
const ProductDetails = React.lazy(() => import("./views/pages/products/Details"));
const ProductActions = React.lazy(() => import("./views/pages/products/Actions"));
const Suppliers = React.lazy(() => import("./views/pages/suppliers/Suppliers"));
const SupplierActions = React.lazy(() => import("./views/pages/suppliers/Actions"));
const Customers = React.lazy(() => import("./views/pages/customers/Customers"));
const CustomerActions = React.lazy(() => import("./views/pages/customers/Actions"));
const PO = React.lazy(() => import("./views/pages/purchaseOrders/PurchaseOrders"));
const POActions = React.lazy(() => import("./views/pages/purchaseOrders/Actions"));
const Invoices = React.lazy(() => import("./views/pages/invoices/Invoices"));
const InvoiceActions = React.lazy(() => import("./views/pages/invoices/Actions"));
const Sales = React.lazy(() => import("./views/pages/sales/Sales"));
const SalesActions = React.lazy(() => import("./views/pages/sales/Actions"));
const Receipts = React.lazy(() => import("./views/pages/receipts/Receipts"));
const ReceiptActions = React.lazy(() => import("./views/pages/receipts/Actions"));
const StockAdjustments = React.lazy(() => import("./views/pages/stockAdjustments/StockAdjustments"));
const StockAdjustmentActions = React.lazy(() => import("./views/pages/stockAdjustments/Actions"));
const GR = React.lazy(() => import("./views/pages/goodsReceipts/GoodsReceipts"));
const GRActions = React.lazy(() => import("./views/pages/goodsReceipts/Actions"));
const Returns = React.lazy(() => import("./views/pages/returns/Returns"));
const ReturnActions = React.lazy(() => import("./views/pages/returns/Actions"));

const Categories = React.lazy(() => import("./views/pages/categories/Categories"));
const Stocks = React.lazy(() => import("./views/pages/stocks/Stocks"));
const StockActions = React.lazy(() => import("./views/pages/stocks/Actions"));
const CategoryActions = React.lazy(() => import("./views/pages/categories/Actions"));
const Users = React.lazy(() => import("./views/pages/users/Users"));
const UserActions = React.lazy(() => import("./views/pages/users/Actions"));
const WorkPlans = React.lazy(() => import("./views/pages/workPlans/WorkPlans"));
const Visitations = React.lazy(() => import("./views/pages/visitations/Visitations"));
const VisitationDetails = React.lazy(() => import("./views/pages/visitations/Details"));
const StoreAnalytics = React.lazy(() => import("./views/pages/analytics/Stores"));
const UplineAnalytics = React.lazy(() => import("./views/pages/analytics/Uplines"));
const StockAnalytics = React.lazy(() => import("./views/pages/analytics/Stocks"));
const SMDAnalytics = React.lazy(() => import("./views/pages/analytics/SMD"));
const Stores = React.lazy(() => import("./views/pages/stores/Stores"));
const StoreDetails = React.lazy(() => import("./views/pages/stores/Details"));
const StoreActions = React.lazy(() => import("./views/pages/stores/Actions"));
const VisitationNotes = React.lazy(() => import("./views/pages/analytics/Notes"));
const routes = [
  {
    path: "/stocks",
    name: "Stocks",
    authKey: AUTH_KEY.stocks,
    element: Stocks,
  },
  {
    path: "/stocks/actions/:id",
    name: "Stock Actions",
    authKey: AUTH_KEY.stocks_actions,
    element: StockActions,
  },
  {
    path: "/stocks/actions",
    name: "Stock Actions",
    authKey: AUTH_KEY.stocks_actions,
    element: StockActions,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    authKey: AUTH_KEY.dashboard,
    element: DashboardView,
  },
  {
    path: "/products",
    name: "Products",
    authKey: AUTH_KEY.products,
    element: Products,
  },
  {
    path: "/product/Details/:id",
    name: "Product Details",
    authKey: AUTH_KEY.product_actions,
    element: ProductDetails,
  },
  {
    path: "/product/actions/:id",
    name: "Product Actions",
    authKey: AUTH_KEY.product_actions,
    element: ProductActions,
  },
  {
    path: "/product/actions",
    name: "Product Actions",
    authKey: AUTH_KEY.product_actions,
    element: ProductActions,
  },
  {
    path: "/categories",
    name: "Categories",
    authKey: AUTH_KEY.categories,
    element: Categories,
  },
  {
    path: "/category-actions",
    name: "Categories Actions",
    authKey: AUTH_KEY.category_actions,
    element: CategoryActions,
  },
  {
    path: "/stores",
    name: "Stores",
    authKey: AUTH_KEY.stores,
    element: Stores,
  },
  {
    path: "/stores/details/:id",
    name: "Store Details",
    authKey: AUTH_KEY.store_actions,
    element: StoreDetails,
  },
  {
    path: "/stores/actions/:id",
    name: "Store Actions",
    authKey: AUTH_KEY.store_actions,
    element: StoreActions,
  },
  {
    path: "/stores/actions",
    name: "Store Actions",
    authKey: AUTH_KEY.store_actions,
    element: StoreActions,
  },

  {
    path: "/users",
    name: "Users",
    authKey: AUTH_KEY.users,
    element: Users,
  },
  {
    path: "/user-actions",
    name: "Users Actions",
    authKey: AUTH_KEY.user_actions,
    element: UserActions,
  },
  {
    path: "/work-plans",
    name: "WorkPlans",
    authKey: AUTH_KEY.work_plans,
    element: WorkPlans,
  },
  {
    path: "/visitations",
    name: "Visitations",
    authKey: AUTH_KEY.visitations,
    element: Visitations,
  },
  {
    path: "/visitations/details/:id",
    name: "Visitation Details",
    authKey: AUTH_KEY.visitations,
    element: VisitationDetails,
  },
  {
    path: "/store-analytics",
    name: "StoreAnalytics",
    authKey: AUTH_KEY.analytics,
    element: StoreAnalytics,
  },
  {
    path: "/upline-analytics",
    name: "UplineAnalytics",
    authKey: AUTH_KEY.analytics,
    element: UplineAnalytics,
  },
  {
    path: "/smd-analytics",
    name: "SMDAnalytics",
    authKey: AUTH_KEY.analytics,
    element: SMDAnalytics,
  },
  {
    path: "/visitation-notes",
    name: "Visitation Notes",
    authKey: AUTH_KEY.visitationNotes,
    element: VisitationNotes,
  },
  {
    path: "/stock-analytics",
    name: "StockAnalytics",
    authKey: AUTH_KEY.analytics,
    element: StockAnalytics,
  },
  {
    path: "/suppliers",
    name: "Suppliers",
    authKey: AUTH_KEY.suppliers,
    element: Suppliers,
  },
  {
    path: "/supplier-actions",
    name: "Supplier Actions",
    authKey: AUTH_KEY.supplier_actions,
    element: SupplierActions,
  },
  {
    path: "/customers",
    name: "Customers",
    authKey: AUTH_KEY.customers,
    element: Customers,
  },
  {
    path: "/customer-actions",
    name: "Customer Actions",
    authKey: AUTH_KEY.customer_actions,
    element: CustomerActions,
  },
  {
    path: "/purchase-orders",
    name: "PO",
    authKey: AUTH_KEY.purchase_orders,
    element: PO,
  },
  {
    path: "/purchase-order-actions",
    name: "PO Actions",
    authKey: AUTH_KEY.purchase_order_actions,
    element: POActions,
  },
  {
    path: "/goods-receipts",
    name: "GR",
    authKey: AUTH_KEY.goods_receipts,
    element: GR,
  },
  {
    path: "/goods-receipt-actions",
    name: "GR Actions",
    authKey: AUTH_KEY.goods_receipt_actions,
    element: GRActions,
  },
  {
    path: "/invoices",
    name: "Invoices",
    authKey: AUTH_KEY.invoices,
    element: Invoices,
  },
  {
    path: "/invoice-actions",
    name: "Invoice Actions",
    authKey: AUTH_KEY.invoice_actions,
    element: InvoiceActions,
  },
  {
    path: "/returns",
    name: "Returns",
    authKey: AUTH_KEY.returns,
    element: Returns,
  },
  {
    path: "/return-actions",
    name: "Return Actions",
    authKey: AUTH_KEY.return_actions,
    element: ReturnActions,
  },
  {
    path: "/sales",
    name: "Sales",
    authKey: AUTH_KEY.sales,
    element: Sales,
  },
  {
    path: "/sales-actions",
    name: "Sales Actions",
    authKey: AUTH_KEY.sales_actions,
    element: SalesActions,
  },
  {
    path: "/receipts",
    name: "Receipts",
    authKey: AUTH_KEY.receipts,
    element: Receipts,
  },
  {
    path: "/receipt-actions",
    name: "Receipts Actions",
    authKey: AUTH_KEY.receipt_actions,
    element: ReceiptActions,
  },
  {
    path: "/stock-adjustments",
    name: "Stock Adjustments",
    authKey: AUTH_KEY.stockAdjustments,
    element: StockAdjustments,
  },
  {
    path: "/stock-adjustment-actions",
    name: "Stock Adjustment Actions",
    authKey: AUTH_KEY.stockAdjustmentActions,
    element: StockAdjustmentActions,
  },
  // { path: '/booths', name: 'Booths', element: Booths },
  // { path: '/booth-actions', name: 'Booth Actions', element: BoothActions },
  {
    path: "/branch-analytics",
    name: "Branch Analytics",
    authKey: AUTH_KEY.branch_analytics,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? BranchAnalytics
        : NotAuthorized,
  },
  {
    path: "/cab",
    name: "Cash and Banks",
    authKey: AUTH_KEY.cash_and_bank,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? CAB
        : NotAuthorized,
  },
  {
    path: "/cab-actions",
    name: "Cash and Banks Actions",
    authKey: AUTH_KEY.cash_and_bank_details,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? CABActions
        : NotAuthorized,
  },
  {
    path: "/coa",
    name: "Chart of Accounts",
    authKey: AUTH_KEY.account_chart,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? COA
        : NotAuthorized,
  },
  {
    path: "/coa-actions",
    name: "Chart of Accounts Actions",
    authKey: AUTH_KEY.account_chart_details,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? COAActions
        : NotAuthorized,
  },
  {
    path: "/account-transactions",
    name: "Account Transactions",
    authKey: AUTH_KEY.accounting_transactions,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? AccountTrx
        : NotAuthorized,
  },
  {
    path: "/account-transaction-actions",
    name: "Account Transaction Actions",
    authKey: AUTH_KEY.accounting_transactions_details,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? AccountTrxActions
        : NotAuthorized,
  },
  {
    path: "/roles",
    name: "Role Setting",
    authKey: AUTH_KEY.role_setting,
    element:
      localStorage.getItem("orgID") === "0" || JSON.parse(localStorage.getItem("userDetail"))?.org_id === 0
        ? Roles
        : NotAuthorized,
  },
  { path: "/not-authorized", name: "Not Authorized", element: NotAuthorized },
  // { path: '/theme', name: 'Theme', element: Colors, exact: true },
  // { path: '/theme/colors', name: 'Colors', element: Colors },
  // { path: '/theme/typography', name: 'Typography', element: Typography },
  // { path: '/base', name: 'Base', element: Cards, exact: true },
  // { path: '/base/accordion', name: 'Accordion', element: Accordion },
  // { path: '/base/breadcrumbs', name: 'Breadcrumbs', element: Breadcrumbs },
  // { path: '/base/cards', name: 'Cards', element: Cards },
  // { path: '/base/carousels', name: 'Carousel', element: Carousels },
  // { path: '/base/collapses', name: 'Collapse', element: Collapses },
  // { path: '/base/list-groups', name: 'List Groups', element: ListGroups },
  // { path: '/base/navs', name: 'Navs', element: Navs },
  // { path: '/base/paginations', name: 'Paginations', element: Paginations },
  // { path: '/base/placeholders', name: 'Placeholders', element: Placeholders },
  // { path: '/base/popovers', name: 'Popovers', element: Popovers },
  // { path: '/base/progress', name: 'Progress', element: Progress },
  // { path: '/base/spinners', name: 'Spinners', element: Spinners },
  // { path: '/base/tables', name: 'Tables', element: Tables },
  // { path: '/base/tooltips', name: 'Tooltips', element: Tooltips },
  // { path: '/buttons', name: 'Buttons', element: Buttons, exact: true },
  // { path: '/buttons/buttons', name: 'Buttons', element: Buttons },
  // { path: '/buttons/dropdowns', name: 'Dropdowns', element: Dropdowns },
  // {
  //   path: '/buttons/button-groups',
  //   name: 'Button Groups',
  //   element: ButtonGroups
  // },
  // { path: '/charts', name: 'Charts', element: Charts },
  // { path: '/forms', name: 'Forms', element: FormControl, exact: true },
  // { path: '/forms/form-control', name: 'Form Control', element: FormControl },
  // { path: '/forms/select', name: 'Select', element: Select },
  // {
  //   path: '/forms/checks-radios',
  //   name: 'Checks & Radios',
  //   element: ChecksRadios
  // },
  // { path: '/forms/range', name: 'Range', element: Range },
  // { path: '/forms/input-group', name: 'Input Group', element: InputGroup },
  // {
  //   path: '/forms/floating-labels',
  //   name: 'Floating Labels',
  //   element: FloatingLabels
  // },
  // { path: '/forms/layout', name: 'Layout', element: Layout },
  // { path: '/forms/validation', name: 'Validation', element: Validation },
  // { path: '/icons', exact: true, name: 'Icons', element: CoreUIIcons },
  // { path: '/icons/coreui-icons', name: 'CoreUI Icons', element: CoreUIIcons },
  // { path: '/icons/flags', name: 'Flags', element: Flags },
  // { path: '/icons/brands', name: 'Brands', element: Brands },
  // {
  //   path: '/notifications',
  //   name: 'Notifications',
  //   element: Alerts,
  //   exact: true
  // },
  // { path: '/notifications/alerts', name: 'Alerts', element: Alerts },
  // { path: '/notifications/badges', name: 'Badges', element: Badges },
  // { path: '/notifications/modals', name: 'Modals', element: Modals },
  // { path: '/notifications/toasts', name: 'Toasts', element: Toasts },
  // { path: '/widgets', name: 'Widgets', element: Widgets }
];

export default routes;
